<template>
  <layout
    title="Zukünftige Reiseziele 27/28"
    :banner="$page.props.banner"
    h1="Zukünftige Reiseziele"
    metaDescription="Welches Skigebiet wünscht ihr euch für die Saison 27/28? Sagt uns euer Wunschreiseziel und wir prüfen es für unser zukünftiges Programm."
    metaKeywords="SCOL, SCOL Skireisen, zukünftige Reiseziele, Wunschreiseziel, neue Skigebiete, Skireise Wunsch, Reiseziel vorschlagen"
  >
    <section id="zukuenftige-reiseziele-intro" class="scol-section bg-light">
      <div class="container-fluid py-sm-4 py-md-0">
        <div class="text-center">
          <h2 class="h3">Zukünftige Reiseziele 27/28</h2>
          <p class="mt-3">
            Ihr habt ein Wunsch-Skigebiet, das ihr in unserem Programm vermisst?
            Sagt es uns! Wir sammeln eure Wünsche für die kommende Saison 27/28
            und prüfen, ob wir euer Traumziel ins Programm aufnehmen können.
          </p>
        </div>
      </div>
    </section>
    <section id="zukuenftige-reiseziele-form" class="scol-section">
      <div class="scol-section-caption">
        <h2>Wunschreiseziel melden</h2>
      </div>
      <div class="container container-small">
        <div class="row justify-content-center">
          <div class="col-12">
            <simple-inquiry-form
              post-route="future-destinations.store"
              success-message="Vielen Dank! Wir haben dein Wunschreiseziel notiert."
            />
          </div>
        </div>
      </div>
    </section>
  </layout>
</template>

<script>
import Layout from "./Layouts/Standard";
import SimpleInquiryForm from "../Components/Scol/SimpleInquiryForm.vue";

export default {
  components: {
    Layout,
    SimpleInquiryForm,
  },
};
</script>
